module.exports = __webpack_public_path__ + "img/Home BESS.f14de414.jpg";